/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Mode_KeyInputs */



/**
* | output |
* | --- |
* | "Licence key" |
*
* @param {License_Mode_KeyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_mode_key = /** @type {((inputs?: License_Mode_KeyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Mode_KeyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clé de licence")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lizenzschlüssel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiave di licenza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Лицензионный ключ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clave de licencia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("许可证密钥")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライセンスキー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइसेंस कुंजी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Chave de licença")
	return /** @type {LocalizedString} */ ("Licence key")
});